/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { Stack } from '@mui/material';
import { GridColumns } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import {
  DateRangeFilter,
  FilterOption,
} from '../../../components/ExpenseClaim/FilterInput';
import LmDialog from '../../../components/common/LmDialog';
import LmFilterSection from '../../../components/common/LmFilterSection';
import VegaButton from '../../../components/common/VegaButton';
import VegaDataGrid from '../../../components/common/VegaDataGrid';
import VegaDrawer from '../../../components/common/VegaDrawer';
import VegaPageContent from '../../../components/common/VegaPageContent';
import VegaPageHeader from '../../../components/common/VegaPageHeader';
import { VegaPill } from '../../../components/common/VegaPill';
import VegaText from '../../../components/common/VegaText';
import { PRIMARY } from '../../../constants/style';
import {
  getReceiptsList,
  receiptState,
  setReceiptData,
} from '../../../features/receiptManagmentSlice';
import { useDrawer } from '../../../hooks/useDrawer';
import { useAppDispatch, useAppSelector } from '../../../store';
import {
  ReceiptManagmentViewModel,
  getPillColorForStatus,
} from '../../../types/receiptManagment';
import { GetReceiptsListRequest } from '../../../types/request/receiptManagment';
import { DateUtility } from '../../../utils/DateUtlility';
import ReceiptDetails from './ReceiptDetails';
import ReciptFilterBy from './ReciptFilterBy';

const TODAY = new Date();
const TOMORROW = DateUtility.addDays(TODAY, 1);

const ListOfReceiptsAgent = () => {
  const dispatch = useAppDispatch();
  const { receipts, loading, totalItems } = useAppSelector(receiptState);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [openReceipt, setOpenReceipt] = useState<boolean>(false);
  const [dayFilter, setDayFilter] = useState<string>();
  const [statusFilter, setStatusFilter] = useState<string>();
  const [dateFilter, setDateFilter] = useState<DateRangeFilter>({
    startDate: TODAY.toISOString(),
    endDate: TOMORROW.toISOString(),
  });
  const {
    isOpen: isFilterDrawerOpen,
    open: openFilterDrawer,
    close: closeFilterDrawer,
  } = useDrawer(false);

  const COL_DEF: GridColumns<ReceiptManagmentViewModel[]> = [
    {
      field: 'receiptDate',
      headerName: 'Receipt Date',
      flex: 0.5,
    },
    {
      field: 'receiptId',
      headerName: 'Receipt ID',
      flex: 0.7,
    },

    {
      field: 'lan',
      headerName: 'Loan Account Number',
      flex: 0.7,
    },

    {
      field: 'paymentMode',
      headerName: 'Payment Mode',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.7,
      renderCell: props => {
        const receipt = props.row as unknown as ReceiptManagmentViewModel;
        const color = getPillColorForStatus(receipt.status);
        return (
          <VegaPill
            text={receipt.status}
            backgroundColor={color?.LIGHT}
            textColor={color?.DARK}
            borderColor={color?.DARK}
          />
        );
      },
    },
    {
      field: 'proof',
      headerName: 'Details',
      flex: 0.5,
      renderCell: props => {
        const receipt = props.row as unknown as ReceiptManagmentViewModel;
        return (
          <VegaButton
            text="View Details"
            variant="text"
            sx={{
              color: PRIMARY.darkBlue,
              fontSize: '0.875rem',
              fontWeight: 500,
              px: 0,
            }}
            onClick={() => viewDetails(receipt)}
          />
        );
      },
    },
  ];

  const viewDetails = (receipt: ReceiptManagmentViewModel) => {
    toggleDialog();
    dispatch(setReceiptData(receipt));
  };
  const onClearAllClick = () => {
    setDateFilter({ startDate: '', endDate: '' });
    setDayFilter(undefined);
    setStatusFilter('');
    closeFilterDrawer();
    fetchReceiptsList();
  };

  const onSelectFilterClick = (
    statusFilter: string,
    dateRangeFilter: DateRangeFilter,
    dayFilter?: string
  ) => {
    closeFilterDrawer();
    setDayFilter(dayFilter);
    setStatusFilter(statusFilter);
    setDateFilter(dateRangeFilter);

    const filteredReceiptObj = {
      status: statusFilter,
      page,
      pageSize,
    } as GetReceiptsListRequest;

    if (dateRangeFilter.startDate.length && dateRangeFilter.endDate.length) {
      filteredReceiptObj.toDate = dateRangeFilter.endDate;
      filteredReceiptObj.fromDate = dateRangeFilter.startDate;
    }

    dispatch(getReceiptsList(filteredReceiptObj));
  };

  const toggleDialog = () => {
    setOpenReceipt(!openReceipt);
  };

  const fetchReceiptsList = () => {
    dispatch(getReceiptsList({ page, pageSize }));
  };

  useEffect(() => {
    fetchReceiptsList();
  }, [page, pageSize]);
  return (
    <>
      <VegaPageHeader
        title="History"
        renderRightView={() => (
          <LmFilterSection
            setSearch={() => {}}
            onFilter={() => openFilterDrawer()}
          />
        )}
        sx={{ borderBottom: 'none', paddingBottom: '1rem' }}
      />

      <VegaPageContent>
        <VegaDataGrid
          data={receipts}
          loading={loading}
          columns={COL_DEF}
          idColumn="id"
          page={page}
          pageSize={pageSize}
          rowCount={totalItems}
          paginationMode="server"
          onPageChange={page => setPage(page)}
          onPageSizeChange={size => setPageSize(size)}
        />
      </VegaPageContent>
      <VegaDrawer
        open={isFilterDrawerOpen}
        title={'Filter By'}
        onClose={function (): void {
          closeFilterDrawer();
        }}
      >
        <ReciptFilterBy
          onClearAllClick={onClearAllClick}
          onSelectFilterClick={onSelectFilterClick}
          value={{
            dayFilter: dayFilter,
            statusFilter: statusFilter,
            dateRangeFilter: dateFilter,
          }}
          allowedFilters={[FilterOption.DayFilter, FilterOption.StatusFilter]}
        />
      </VegaDrawer>
      <LmDialog
        fullWidth
        maxWidth="sm"
        open={openReceipt}
        isCloseIcon
        handleClose={toggleDialog}
        buttonComponent={() => <></>}
        headerComponent={() => (
          <Stack
            direction={'row'}
            alignItems={'center'}
            px={4}
            py={2.5}
            gap={2}
            bgcolor={'#E5F7FC'}
          >
            <VegaText
              text="Receipt Details"
              fontWeight={600}
              fontSize={'1.0625rem'}
              color={'black'}
            />
          </Stack>
        )}
      >
        <ReceiptDetails />
      </LmDialog>
    </>
  );
};

export default ListOfReceiptsAgent;
